module.exports = __webpack_public_path__ + "img/its-notmal.010d983b.jpg";